import { BasicPermissionItem } from '../../PermissionItem'
import { Simple } from '../../common'
import { Users } from '../../../cimsPage/instances/admin'

const page = Users
const object = 'User'

export const ViewUser = Simple({
  id: '783B37E9-F911-4D60-AA39-A3D50702BF17',
  page,
  object,
  action: 'View',
})
export const EditUserRole = new BasicPermissionItem({
  id: '2F016FF4-CB8F-45E7-AD6B-9BF8354E52F7',
  page,
  action: 'edit user roles',
  name: 'Edit User Role',
})
export const EditUserPermission = new BasicPermissionItem({
  id: 'C8A14FE0-FE0E-4929-8125-7BB216CADA26',
  page,
  action: 'edit user permissions',
  name: 'Edit User Permission',
})
export type UserPermission =
  | typeof ViewUser
  | typeof EditUserRole
  | typeof EditUserPermission
